import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.css']
})
export class ChangeLanguageOnStartupComponent implements OnInit {

  constructor(private matDialogRef: MatDialogRef<ChangeLanguageOnStartupComponent>) { }

  ngOnInit(): void {
  }
  onContinue(event) {
    this.matDialogRef.close(event);
  }
}
